/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPolicyEN = () => (
  <LegalPageLayout
    title="Privacy Policy"
    subtitle="How Body-Up processes your personal data in accordance with the Swiss FADP (nLPD) and the EU GDPR."
    lastUpdated="Last update: June 21, 2026"
    seoTitle="Privacy Policy | Body-Up Personal Training Nyon"
    seoPath="/privacy-policy"
  >
    <h2>1. Data controller</h2>
    <ul>
      <li><strong>Legal name</strong>: Body-Up, Laurent Wälti</li>
      <li><strong>Legal form</strong>: Sole proprietorship (Raison individuelle, Switzerland)</li>
      <li><strong>Owner</strong>: Laurent Wälti</li>
      <li><strong>UID / Business ID</strong>: CHE-201.319.764</li>
      <li><strong>Trade register number</strong>: CH-550.1.081.439-0 (Vaud)</li>
      <li><strong>Address</strong>: Route des Tattes-d'Oie 95, 1260 Nyon, Switzerland</li>
      <li><strong>Contact</strong>: <a href="mailto:info@body-up.ch">info@body-up.ch</a></li>
    </ul>
    <p className="text-xs text-gray-500">Body-Up has not appointed a Data Protection Officer (DPO). For any data-related question, write to <a href="mailto:info@body-up.ch">info@body-up.ch</a>.</p>

    <h2>2. Data we collect</h2>
    <h3>2.1 Public website</h3>
    <ul>
      <li><strong>Technical info</strong>: IP, browser, pages visited (only with your consent via the cookie banner).</li>
      <li><strong>Contact form</strong>: name, e-mail, message.</li>
    </ul>
    <h3>2.2 Calorie calculator</h3>
    <ul>
      <li><strong>Body & nutritional data</strong>: gender, age, weight, height, body type, goal, activity level, training type, meal pattern.</li>
      <li><strong>E-mail</strong>: to send back your results and link your calculations to a possible account.</li>
    </ul>
    <p>This data stays strictly between you and Body-Up. It is <strong>never</strong> sent to analytics (Google Analytics) or advertising (Meta Pixel) tools, even if you accepted those tools.</p>
    <h3>2.3 Client area</h3>
    <ul>
      <li><strong>Account</strong>: name, e-mail, hashed password (never stored in clear).</li>
      <li><strong>Daily tracking</strong>: food entries, measurements, optional photos, progress log.</li>
      <li><strong>Generated meal plans</strong>: personalized content, recipes, macros.</li>
      <li><strong>Coaching messages</strong> (for plans including coaching): your conversations with the coach.</li>
    </ul>

    <h2>3. Purposes</h2>
    <ul>
      <li>Provide the requested service (calculation, plan, tracking, coaching).</li>
      <li>Send you results and account communications.</li>
      <li>Improve the site (only with your consent on analytics cookies).</li>
      <li>Offer our services (only with your consent on marketing cookies).</li>
      <li>Comply with legal obligations (invoicing, accounting).</li>
    </ul>

    <h2>4. Legal basis</h2>
    <ul>
      <li><strong>Contract performance</strong>: for purchased services and account-based features.</li>
      <li><strong>Consent</strong>: for non-essential cookies, newsletters and marketing.</li>
      <li><strong>Legitimate interest</strong>: site security, fraud prevention.</li>
      <li><strong>Legal obligation</strong>: invoice retention.</li>
    </ul>

    <h2>5. Retention</h2>
    <ul>
      <li>Client account and calculations: as long as your account is active, then deletion or anonymization within 12 months of your request.</li>
      <li>Invoicing data: 10 years (Swiss accounting obligation).</li>
      <li>Analytics and marketing cookies: max 13 months after last visit.</li>
      <li>Consent choice: 12 months, or until policy update.</li>
    </ul>

    <h2>6. Providers and recipients</h2>
    <p>Body-Up relies on the following providers. <strong>No nutritional, body or plan data is transmitted to third-party tools.</strong></p>
    <ul>
      <li><strong>MongoDB Atlas / Hosting</strong>: encrypted storage of accounts and client data (Switzerland / EU).</li>
      <li><strong>Stripe</strong>: secure payment processing (Ireland / USA with contractual safeguards).</li>
      <li><strong>SMTP <code>info@body-up.ch</code></strong>: transactional e-mails (Switzerland).</li>
      <li><strong>Google Fonts</strong>: font delivery (Google CDN).</li>
      <li><strong>Booking system Pure Informatique</strong>: appointment booking (Switzerland).</li>
      <li><strong>Google Analytics / Meta Pixel</strong>: <em>not active today</em>. Will be enabled later and only after your consent.</li>
    </ul>

    <h2>7. Transfers outside Switzerland / EU</h2>
    <p>Some providers (Stripe, Google Fonts) process data in the United States, based on EU standard contractual clauses and, when applicable, on the Swiss–US Data Privacy Framework adequacy decision.</p>

    <h2>8. Your rights</h2>
    <ul>
      <li>Access, rectification, erasure, opposition, portability, withdrawal of consent.</li>
      <li>To exercise: <a href="mailto:info@body-up.ch">info@body-up.ch</a>. Proof of identity may be requested. Response within 30 days.</li>
    </ul>

    <h2>9. Sensitive data commitments</h2>
    <p>Nutritional, body and health-related data you enter (weight, height, goals, allergies, meal plans, coaching messages) are considered particularly sensitive. Therefore:</p>
    <ul>
      <li>They are never sent to Google Analytics, Meta Pixel or any advertising tool.</li>
      <li>They never leave the Body-Up perimeter and its necessary technical providers (hosting, e-mail).</li>
      <li>They are never sold, traded or shared for commercial purposes.</li>
    </ul>
    <p className="text-xs text-zinc-500 italic">Recommendations from the calculator or plans are not medical advice. When in doubt, consult a healthcare professional.</p>

    <h2>10. Security</h2>
    <p>Passwords are hashed (bcrypt). Communications use HTTPS. Admin access is multi-factor when possible and is logged.</p>

    <h2>11. Complaint</h2>
    <p>You may file a complaint with the Swiss Federal Data Protection Commissioner (FDPIC) or the data protection authority of your EU country of residence.</p>

    <h2>12. Policy updates</h2>
    <p>This policy may evolve. In case of an important change (new provider, new purpose, new cookies), you will be asked for consent again.</p>
  </LegalPageLayout>
);

export default PrivacyPolicyEN;
